import React from "react";
import Modal from "react-native-modal";
import ResponsiveContent from "../shared/responsive-content";
import { View, Pressable, Text, ScrollView } from "react-native";
import CloseIcon from "@/assets/svgs/close-icon";
import { Button } from "../ui/button";
import LessonSubmittedIllustration from "@/assets/illustrations/lesson-submitted-illustration";
import { AppBar } from "../ui/app-bar";

function LessonSubmittedModal({
  isVisible,
  onClose,
}: {
  isVisible: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={isVisible}
      onBackdropPress={onClose}
      onDismiss={onClose}
      useNativeDriver
      useNativeDriverForBackdrop
      hideModalContentWhileAnimating
    >
      <ResponsiveContent className="h-lvh bg-teachLoop-creamDark">
        <AppBar />
        <ScrollView>
          <View className="items-end px-5 pt-4">
            <Pressable onPress={onClose} className="active:opacity-80">
              <CloseIcon
                pathClassName="stroke-teachLoop-textPrimary"
                className="size-6"
              />
            </Pressable>
          </View>

          <View className="gap-8 px-5">
            <View className="items-center">
              <LessonSubmittedIllustration />
            </View>
            <Text className="font-geologica-medium text-center font-medium text-[32px] leading-[1.5] text-teachLoop-accentPrimary">
              Nice work!
            </Text>
            <Text className="text-center text-xl font-geologica-medium font-medium leading-[1.5] text-teachLoop-textPrimary">
              Your lesson report is being generated..
            </Text>
            <Text className="text-center text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary">
              You can check back again in 20 minutes to see the report. Once you
              do, please review it to process your payment.
            </Text>
            <View className="items-center">
              <Button
                fullWidth
                size="sm"
                intent="textPrimary"
                outline
                onPress={onClose}
                className="border px-8"
              >
                <Button.Text intent="textPrimary" size="sm">
                  Got it
                </Button.Text>
              </Button>
            </View>
          </View>

          <View className="h-3" />
        </ScrollView>
      </ResponsiveContent>
    </Modal>
  );
}

export default LessonSubmittedModal;
